export default __webpack_public_path__ + "static/1-1307d64f6bc5c517b60ce66a562e5a04.png";